import { Badge } from "@web/components/ui/badge";
import { getBadgeStyle } from "@repo/share-log-web-utils";
import { MethodIcon } from "@web/components/ui/method-icon";

interface ColorBadgeProps {
  name: string;
  color?: string | null;
  icon?: string | null;
}

export function ColorBadge({ name, color, icon }: ColorBadgeProps) {
  if (!color) {
    return (
      <Badge variant="muted">
        {icon && <MethodIcon name={icon} className="mr-1" />}
        {name}
      </Badge>
    );
  }

  return (
    <span
      className="inline-flex items-center px-2 py-0.5 text-xs font-medium rounded"
      style={getBadgeStyle(color)}
    >
      {icon && <MethodIcon name={icon} className="mr-1" />}
      {name}
    </span>
  );
}
